module.exports = __webpack_public_path__ + "img/donation-success.58e45df0.svg";